import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Content, Provider, Root, Trigger } from "./styles";
import { Button } from "../Button";
import { useMediaQuery } from "../../../hooks";
import { theme } from "../../core/tokens";
export function Tooltip({ children, content, side = "top", title, maxWidth = "190px", onDialog, }) {
    const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.large})`);
    if (!isDesktop)
        return (_jsx(Button, { variant: "text", onClick: (e) => {
                e.stopPropagation();
                onDialog?.({
                    heading: {
                        title: title || "Atenção",
                        showCloseButton: true,
                    },
                    content: {
                        description: "",
                        children: content,
                    },
                    footer: {
                        primaryButton: {
                            label: "Entendi",
                        },
                    },
                });
            }, children: children }));
    return (_jsx(Provider, { delayDuration: 0, children: _jsxs(Root, { children: [_jsx(Content, { side: side, maxWidth: maxWidth, children: content }), _jsx(Trigger, { children: children })] }) }));
}
//# sourceMappingURL=index.js.map